import './PendingRequests.css';
import Table from 'react-bootstrap/Table';
import PendingRequestsRow from '../PendingRequestsRow/PendingRequestsRow';
import {QuestionCircle} from 'react-bootstrap-icons';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState, useRef } from 'react';

 function PendingRequests(props){
    const dispatch = useDispatch();
    const request = useSelector((store) => store.requestReducer.pending);
    const requestNewest = useSelector((store) => store.requestNewestReducer.pending);
    const requestName = useSelector((store) => store.requestNameReducer.pending);
    const [searchTerm, setSearchTerm ] = useState("");
    const [searchResults,setSearchResult] = useState([]);
    

console.log( "sortvalue:"+ props.sortValue );

  useEffect(() => {
    dispatch({ type: 'FETCH_REQUESTS' });
     dispatch({ type: 'FETCH_NEWEST_REQUESTS' });
    dispatch({ type: 'FETCH_NAME_REQUESTS' });
     dispatch({ type: 'FETCH_CLIENTS' });
  }, []);
    const inputEl = useRef("");
          const searchHandler = (searchTerm) =>{
        setSearchTerm(searchTerm);
        if(searchTerm !==""){
            const newClientList = request.filter((request)=>{
              return Object.values(request).join(" ").toLowerCase().includes(searchTerm.toLowerCase());
            })
            setSearchResult(newClientList);
            console.log("test"+searchResults);
        }
        else{
            setSearchResult(request);
             console.log("test"+searchResults);
        }
        }

        

    const getSearchTerm = () =>{
      
        searchHandler(inputEl.current.value);

    }
   
    
    return(
       <>
        <input ref={inputEl} size="40" type="text" value={searchTerm} onChange={getSearchTerm} placeholder="type to search"></input> <button onClick ={(e) => (setSearchTerm(""))} >CLEAR</button>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th className="text-center">
                        Referral Date
                    </th>
                    <th className="text-center">
                        Client Name
                    </th>
                    <th className="text-center">
                        Requested Items
                    </th>
                    <th className="text-center">
                        Actions 
                    </th>
                </tr>
            </thead>
            {searchTerm.length<1?

            <>
            {props.sortValue == 0 ?
            <PendingRequestsRow searchResults = {requestNewest}/>
            :
            <>
                {props.sortValue == 1 ?
                    <PendingRequestsRow searchResults = {request}/>
                    :
                    <>
                        {props.sortValue == 2?
                        <PendingRequestsRow searchResults = {requestName}/>
                            :
                            <> </> 
                        }
                    </>
                }
            </>
            }

            </>
            :
             <PendingRequestsRow
            
             searchResults = {searchResults}
        
             
             />
            
            }
        </Table>
        </>
    );
}

export default PendingRequests;